import { render, staticRenderFns } from "./sysDetails.vue?vue&type=template&id=3df802a4&scoped=true&"
import script from "./sysDetails.vue?vue&type=script&lang=js&"
export * from "./sysDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df802a4",
  null
  
)

export default component.exports